import { render, staticRenderFns } from "./TrafficForm.vue?vue&type=template&id=64c62350&"
import script from "./TrafficForm.vue?vue&type=script&lang=js&"
export * from "./TrafficForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports